import { sharedCareScoutQuestions } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedCareScoutQuestions,
  dailyBenefitAmount: {
    id: 'daily-benefit-amount',
    questionRef: 'dailyBenefitAmount',
    title: 'Daily Benefit Amount',
    type: 'radio',
    required: true,
    options: [
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
  },

  // Page 23 (Long Term Care Insurance Policy Replacement Review)
  replacementApplicantName: {
    id: 'replacement-applicant-name',
    questionRef: 'replacementApplicantName',
    title: "Applicant's Name (Replacement Application)",
    type: 'text',
    required: true,
  },

  nameOfInsurer: {
    id: 'name-of-insurer',
    questionRef: 'nameOfInsurer',
    title: 'Name of Insurer',
    type: 'text',
    required: true,
  },

  substantiallyReasons: {
    id: 'substantially-reasons',
    questionRef: 'substantiallyReasons',
    title:
      'The CareScout Insurance Company policy is substantially better for the following reasons:',
    type: 'multiselect',
    required: true,
    options: [
      {
        id: 'reduction-in-premium-rates-with-similar-benefits',
        value: 'Reduction in premium rates with similar benefits',
      },
      {
        id: 'increases-daily-monthly-benefit',
        value: 'Increases daily/monthly benefit',
      },
      {
        id: 'offers-additional-benefit-options-and-or-riders',
        value: 'Offers additional benefit options and/or riders',
      },
      {
        id: 'financial-strength-of-replacing-company',
        value: 'Financial strength of the replacing company',
      },
      {
        id: 'other',
        value: 'Other',
      },
    ],
  },

  substantiallyReasonsOther: {
    id: 'substantially-reasons-other',
    questionRef: 'substantiallyReasonsOther',
    title: 'Other Reasons',
    type: 'text',
    required: false,
    conditional: {
      visible: {
        field: 'substantiallyReasons',
        operator: 'contains',
        value: 'other',
      },
      required: {
        field: 'substantiallyReasons',
        operator: 'contains',
        value: 'other',
      },
    },
  },
};

export const careScoutWIFormDefinition: PolicyFormDefinition = {
  sections: [
    sharedCareScoutSections.coverageSelection,
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    sharedCareScoutSections.medicalQuestions,
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    // Page 22 (Long Term Care Insurance Policy Replacement Review)
    {
      id: 'ltc-insurance-policy-replacement-review',
      title: 'Long Term Care Insurance Policy Replacement Review',
      subsections: [
        {
          id: 'ltc-insurance-policy-replacement-review-questions',
          title: 'Long Term Care Insurance Policy Replacement Review',
          questionGroups: [
            {
              id: 'ltc-replacement-info',
              format: 'grid',
              questions: ['replacementApplicantName', 'nameOfInsurer'],
            },
            {
              id: 'ltc-replacement-reasons',
              format: 'default',
              questions: ['substantiallyReasons', 'substantiallyReasonsOther'],
            },
          ],
        },
      ],
      conditional: {
        visible: {
          field: 'intendToReplace',
          operator: 'equals',
          value: 'yes',
        },
      },
    },
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions,
};
